import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import lineChart from '@/components/bigDataChart/lineChart';
import { getAction } from '@/api/manage';
import moment from "moment";
export default {
  name: 'CarExpendList',
  mixins: [],
  data: function data() {
    return {
      title: '车辆耗能统计表单',
      limitSelectDate: {},
      chartBoxHeight: '604px',
      url: {
        queryCarExpend: '/ea/asset/car/use/queryCarExpend'
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  components: {
    lineChart: lineChart
  },
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '590px'
    },
    carId: {
      type: Number,
      default: null
    }
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.startDate = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.endDate = this.limitSelectDate.max.format('YYYY-MM-DD');
    this.searchChart();
  },
  methods: {
    onDateChange: function onDateChange(value, dateString) {
      this.startDate = dateString[0];
      this.endDate = dateString[1];
    },
    searchChart: function searchChart() {
      var _this = this;

      var params = {
        stime: this.startDate,
        etime: this.endDate,
        carId: this.carId
      };
      getAction(this.url.queryCarExpend, params).then(function (res) {
        if (res.success) {
          var data = {
            seriesData: [],
            xData: [],
            legendData: ['行驶里程', '加油费用', '过路费用']
          }; // var legendSelect = {
          //   行驶里程: true,
          //   加油费用: false,
          //   过路费用: false
          // }

          var total = [];
          var oilFee = [];
          var roadFee = [];
          res.result.forEach(function (v, i) {
            data.xData.push(v.edate);
            total.push(v.total);
            oilFee.push(v.oilFee);
            roadFee.push(v.roadFee);
          });
          data.seriesData = [{
            name: '行驶里程',
            data: total,
            areaStyle: {},
            type: 'line'
          }, {
            name: '加油费用',
            data: oilFee,
            areaStyle: {},
            type: 'line'
          }, {
            name: '过路费用',
            data: roadFee,
            areaStyle: {},
            type: 'line'
          }];

          _this.$refs.chart.initLineChart(data, '#000');
        }
      });
    }
  }
};